import styled from 'styled-components';

type ContainerPropsType = {
  spacing?: string;
};
export const Container = styled.div<ContainerPropsType>`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Row = styled.div`
  display: flex;
  gap: 20px;
`;
type ContentPropsType = {
  flexGrow?: number;
  flexBasis?: string;
};

export const Content = styled.div<ContentPropsType>`
  flex-grow: ${(props) => (props.flexGrow ? props.flexGrow : 0)};
  flex-basis: ${(props) => (props.flexBasis ? props.flexBasis : 'auto')};

  p {
    font-family: Roboto;
    font-size: 12px;
    font-weight: 400;
    text-align: justify;
    margin-top: 0px;
    margin-bottom: 8px;
  }

  .margin {
    margin-bottom: 20px;
  }
`;

export const LoadingContainer = styled.div`
  height: 370px;
  @media (min-width: 768px) {
    // height: 
  }
`;
